unit WeightScaleType;
{

/* Initail. */

}
interface

uses
  JS;

type
  TWeightScaleType = class
  private
    fWeightScaleKey: String;
    fValue: String;
    fActive: Boolean;
  public
    property WeightScaleKey: String read fWeightScaleKey;
    property Value: String read fValue;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TWeightScaleType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fWeightScaleKey := String(JSObject_Type['weightScaleKey']);
    fValue := String(JSObject_Type['value']);
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
